import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import isEqual from 'lodash/lang/isEqual';

function isTouchDevice() {
  return (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

export default class HpAwards extends WebComponent {
  static defaultProps = {
    activeClassName: 'active',
  }

  constructor(props) {
    super(props);

    this.objects = {};

    this.state = {
      isDown: false,
      startX: null,
      scrollLeft: null,
    };

    this.handleStart = this.handleStart.bind(this);
    this.handleEnd = this.handleEnd.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleMove = this.handleMove.bind(this);
  }

  didMount() {
    this.objects.startEventType = 'mousedown';
    this.objects.endEventType = 'mouseup';
    this.objects.cancelEventType = 'mouseleave';
    this.objects.moveEventType = 'mousemove';

    if (isTouchDevice()) {
      this.objects.startEventType = 'touchstart';
      this.objects.endEventType = 'touchend';
      this.objects.cancelEventType = 'touchcancel';
      this.objects.moveEventType = 'touchmove';
    }

    this.on(this.objects.startEventType, this.handleStart);
    this.on(this.objects.endEventType, this.handleEnd);
    this.on(this.objects.cancelEventType, this.handleCancel);
    this.on(this.objects.moveEventType, this.handleMove);
  }

  update(prevProps, prevState) {
    const {
      isDown,
    } = this.state;

    const {
      isDown: prevIsDown,
    } = prevState;

    if (!isEqual(isDown, prevIsDown)) {
      this.updateIsDown();
    }
  }

  updateIsDown() {
    const {
      activeClassName,
    } = this.props;

    const {
      isDown,
    } = this.state;

    if (isDown) {
      this.element.classList.add(activeClassName);
    } else {
      this.element.classList.remove(activeClassName);
    }
  }

  handleStart(e) {
    const pageX = isTouchDevice() ? e.touches[0].pageX : e.pageX;
    this.setState({
      isDown: true,
      startX: pageX - this.element.offsetLeft,
      scrollLeft: this.element.scrollLeft,
    });
  }

  handleEnd() {
    this.finishedHandle();
  }

  handleCancel() {
    this.finishedHandle();
  }

  handleMove(e) {
    const {
      isDown,
      startX,
      scrollLeft,
    } = this.state;

    if (!isDown) return;
    e.preventDefault();

    const pageX = isTouchDevice() ? e.touches[0].pageX : e.pageX;
    const x = pageX - this.element.offsetLeft;
    const walk = (x - startX) * 3;
    this.element.scrollLeft = scrollLeft - walk;
  }

  finishedHandle() {
    this.setState({
      isDown: false,
    });
  }
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/HpAwards.js